import { ILxsRegisterResources } from '../modules/lxs-register/lxs-register.props.autogenerated';

export interface ITitleOption {
    value: string;
    resourceKey: keyof ILxsRegisterResources;
}

export const TITLES: ITitleOption[] = [
    { value: 'Mr', resourceKey: 'lxsRegisterTitleMr' },
    { value: 'Ms', resourceKey: 'lxsRegisterTitleMs' }
];
